import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var clampClassname = {
  none: 'tw-line-clamp-none',
  1: 'tw-line-clamp-1',
  2: 'tw-line-clamp-2',
  3: 'tw-line-clamp-3',
  4: 'tw-line-clamp-4',
  5: 'tw-line-clamp-5',
  6: 'tw-line-clamp-6'
};
export var Clamp = function Clamp(_ref) {
  var lines = _ref.lines,
    className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/_jsx("p", {
    className: clsx('tw-block tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-m-0', !!lines && clampClassname[lines], className),
    children: children
  });
};